﻿import { IMenuItem, IMenuItemParent, MenuItemParentType } from "./menuItemBase";
import { PopupMenuItem } from "./popupMenuItem";

type Command = "" | "next" | "previous";
type PopupDirection = "Vertical" | "Horizontal"

export class PopupMenu implements IMenuItemParent{
    public type: MenuItemParentType = "PopUpMenu";
    private _domNode: HTMLElement;
    public parent: IMenuItem;
    private menuItems: IMenuItem[] = [];
    private firstItem: IMenuItem | null = null;
    private lastItem: IMenuItem | null = null;
    public hasHover: boolean = false;
    public hasFocus: boolean = false;
    private popupDirection: PopupDirection;

    public SetFocusToItem(item: IMenuItem) {
        for (let i: number = 0; i < this.menuItems.length; i++) {
            const popupMenuItem = this.menuItems[i];
            popupMenuItem.domNode.tabIndex = -1;
        }

        item.domNode.focus();
        item.domNode.tabIndex = 0;
    }

    public SetFocusToFirstItem() {
        if (this.firstItem !== null) {
            this.SetFocusToItem(this.firstItem);
        }
    }

    public SetFocusToLastItem() {
        if (this.lastItem !== null) {
            this.SetFocusToItem(this.lastItem);
        }
    }


    /**
     * Set keyboard focus to the element that precedes the currently selected one
     *
     * @param currentItem The currently selected popup item
     * @memberof PopupMenu
     */
    public SetFocusToPreviousItem(currentItem: IMenuItem) {
        let index: number;
        let newItem: IMenuItem | null;

        if (currentItem === this.firstItem) {
            newItem = this.lastItem;
        } else {
            index = this.menuItems.indexOf(currentItem);
            newItem = this.menuItems[index - 1];
        }
        if (newItem !== null) {
            this.SetFocusToItem(newItem);
        }
    }

    /**
     * Set keyboard focus to the element that follows the currently selected one
     *
     * @param {PopupMenuItem} currentItem The currently selected popup item
     * @memberof PopupMenu
     */
    public SetFocusToNextItem(currentItem: PopupMenuItem) {
        let index: number;
        let newItem: IMenuItem | null;
        if (currentItem === this.lastItem) {
            newItem = this.firstItem;
        } else {
            index = this.menuItems.indexOf(currentItem);
            newItem = this.menuItems[index + 1];
        }
        if (newItem !== null) {
            this.SetFocusToItem(newItem);
        }
    }

    public SetFocusToController(command: Command) {
        //CREATE STRUCT FOR COMMAND
        switch (command) {
            case "":
                if (this.parent?.domNode) {
                    this.parent.domNode.focus();
                }
                return;

            case "previous":
                this.parent.menu.SetFocusToPreviousItem(this.parent);
                break;

                case "next":
                this.parent.menu.SetFocusToPreviousItem(this.parent);
                break;
        }
    }

    private handleMouseover() {
        this.hasHover = true;
    }

    private handleMouseout() {
        this.hasHover = false;
        setTimeout(this.Close.bind(this, false), 400);
    }

    public Open() {
        const rect: DOMRect = this.parent.domNode.getBoundingClientRect();

        // Set CSS properties
        if (this._domNode) {
            this._domNode.style.display = "block";
            this._domNode.style.position = "absolute";
            this._domNode.style.top = this.popupDirection == "Vertical" ? `${rect.height}px` : "0px";
            this._domNode.style.zIndex = "100";
        }

        this.parent.SetExpanded(true);
    }

    public Close(force: boolean = false) {
        let controllerHasHover: boolean = false;
        if (this.parent) {
            controllerHasHover = this.parent.hasHover;
        }

        let hasFocus: boolean = this.hasFocus;

        for (let i: number = 0; i < this.menuItems?.length; i++) {
            let mi: IMenuItem = this.menuItems[i];
            if (mi.menu) {
                hasFocus = hasFocus || mi.menu.hasFocus;
            }
        }

        if (
            force ||
            (!this.hasFocus && !this.hasHover && !controllerHasHover)
            ) {
                if (this._domNode) {
                    this._domNode.style.display = "none";
                    this._domNode.style.zIndex = "0";
                    this._domNode.tabIndex = -1;
                    this.parent.SetExpanded(false);
            }
        }
    }

    constructor(domNode: HTMLElement, parent: IMenuItem, popupDirection : PopupDirection = "Horizontal") {
        this._domNode = domNode;
        this.parent = parent;
        this.popupDirection = popupDirection;
        this._domNode.addEventListener(
            "mouseover",
            this.handleMouseover.bind(this)
        );
        this._domNode.addEventListener(
            "mouseout",
            this.handleMouseout.bind(this)
        );

        // Traverse the element children of domNode: configure each with
        // menuitem role behavior and store reference in menuitems array.
        let childElement: Element | null = this._domNode.firstElementChild;
        while (childElement) {
            let menuElement: HTMLElement | null = <HTMLElement>(
                childElement.firstElementChild
            );

            if (menuElement !== null) {
                let menuItem: PopupMenuItem = new PopupMenuItem(
                    menuElement,
                    this
                );
                this.menuItems.push(menuItem);
                childElement = childElement.nextElementSibling;
            } else {
                break;
            }
        }

        //Use populated menuitems array to initialize firstItem and lastItem.
        let numItems: number = this.menuItems.length;
        if (numItems > 0) {
            this.firstItem = this.menuItems[0];
            this.lastItem = this.menuItems[numItems - 1];
        }
    }

}
